import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './useUser';
import { getDefaultAuthorizedPath } from '../auth/authorization';
import HomePage from '../pages/home';

// LIVE-001 / UI-003A: An already-authenticated user landing on the public root
// ("/") should go straight to their own default destination instead of
// re-navigating the public splash page. The destination comes from the shared
// `getDefaultAuthorizedPath` helper (staff -> /me, ALUM -> /me/alum) rather
// than a role map local to this component, so root stays in step with
// LoginPage and the rest of the authorization boundary. A profile with no
// valid default (missing, pending, disabled, unknown role) falls back to
// /unauthorized rather than being handed a staff surface.
//
// `loading` covers both the initial session check and the profile fetch (see
// AuthProvider), so nothing renders until the role is actually known, avoiding
// a flash of the public page and avoiding a redirect decided on a half-loaded
// profile. If session detection fails, useUser's `user` stays null and this
// simply falls through to the existing public HomePage below, so a failure
// never breaks public access or creates a redirect loop.
const RootRoute = () => {
  const { user, profile, loading } = useUser();

  if (loading) return null;
  if (user) {
    return <Navigate to={getDefaultAuthorizedPath(profile?.role) || '/unauthorized'} replace />;
  }

  return <HomePage />;
};

export default RootRoute;
